
import './App.css';
import React,{useEffect} from 'react';
import Navbar from './components/Navbar';
import About from './views/About';
import Portfolio from './views/Portfolio';
import Blog from './views/Blog';
import Home from './views/Home';
import Contact from './views/Contact';
import WOW from "wowjs";


import {BrowserRouter as Router,Routes,Route} from 'react-router-dom'
import './Styles/Home.css'
import Footer from './components/Footer';
import BlogsArticleDetail from './views/BlogsArticleDetail';
import PortfolioCardArticleDetail from './views/PortfolioCardArticleDetail';
function App() {
  useEffect(() => {
    new WOW.WOW().init();
  }, []);


  return (
    <Router>
    <div className="App">
      <header className=" App-header">
      
          <Navbar/>
          <Routes>
            <Route path='/' element={<Home/>}/>
            <Route path='/about' element={<About/>}/>
            <Route path='/portfolio' element={<Portfolio/>}/>
            <Route path='/blog' element={<Blog/>}/>
            <Route path='/contact' element={<Contact/>}/>
            <Route path="/blog/:id" element={<BlogsArticleDetail />} />
            <Route path="/portfolio/:id" element={<PortfolioCardArticleDetail />} />
          </Routes>
          <Footer/>
      </header>
    </div>
    </Router>
  );
}

export default App;
